import React from 'react';
import { reduxForm } from 'redux-form';
import { Field } from 'redux-form';
import { SaveButton } from '../../../../itrust_common/components/others';
import { Input } from '../../../../itrust_common/components/form';

let TagForm = props => {
  const { handleSubmit, saving } = props;
  return (
      <form onSubmit={handleSubmit}>
        <div className="row mt-5">
          <Field name="name" placeholder="Add new tag and press enter to save ..." component={Input} className="form-control" wrapperClasses="form-group mb-0 col-12 " autoComplete="off"/>
        </div>
        <SaveButton buttonClasses="btn-sm float-right my-3 d-none" saving={saving} />
      </form>
  )
}

TagForm = reduxForm({
  form: 'tagForm',
})(TagForm)

export default TagForm;